import React from 'react';
import PropTypes from 'prop-types';
import { normalizeVenueSpacesForDisplay } from '../../../utils/venueSpacesDisplay';

/**
 * Figma-style space scope pills (node 3837-12547): pick venue-wide or a specific space.
 */
const SettingsSpaceScopeBar = ({
  spaces = [],
  value,
  onChange,
  showVenueWide = true,
  venueWideLabel = 'All spaces (venue default)',
  ariaLabel = 'Select space scope',
  className = '',
  /** Hide bar until at least this many spaces (calendar uses 2; settings may show venue-wide with 1). */
  minSpacesToShow = showVenueWide ? 1 : 2
}) => {
  const displaySpaces = normalizeVenueSpacesForDisplay(spaces);
  if (displaySpaces.length < minSpacesToShow) return null;
  if (displaySpaces.length === 0) return null;

  return (
    <div className={`settings-space-scope ${className}`.trim()} role="tablist" aria-label={ariaLabel}>
      {showVenueWide ? (
        <button
          type="button"
          role="tab"
          aria-selected={value == null}
          className={`settings-space-scope-btn${value == null ? ' is-active' : ''}`}
          onClick={() => onChange(null)}
        >
          {venueWideLabel}
        </button>
      ) : null}
      {displaySpaces.map((space) => {
        const id = space.id;
        const isActive = value != null && String(value) === String(id);
        return (
          <button
            key={id || space.name}
            type="button"
            role="tab"
            aria-selected={isActive}
            className={`settings-space-scope-btn${isActive ? ' is-active' : ''}`}
            onClick={() => onChange(id)}
          >
            {space.name}
          </button>
        );
      })}
    </div>
  );
};

SettingsSpaceScopeBar.propTypes = {
  spaces: PropTypes.arrayOf(PropTypes.object),
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  showVenueWide: PropTypes.bool,
  venueWideLabel: PropTypes.string,
  ariaLabel: PropTypes.string,
  className: PropTypes.string,
  minSpacesToShow: PropTypes.number
};

export default SettingsSpaceScopeBar;
